module.exports = __webpack_public_path__ + "img/color-1.0a2f7bc.png";